export const messageOf = (error: unknown): string => {
  if (error && typeof error === 'object') {
    const response = (error as { response?: { message?: string } }).response
    if (response?.message) {
      return response.message
    }
    if ('message' in error && typeof (error as Error).message === 'string') {
      return (error as Error).message
    }
  }
  return 'Something went wrong'
}
